import { render, staticRenderFns } from "./RefundDetailCollapsableCard.vue?vue&type=template&id=695e41c2&scoped=true&"
import script from "./RefundDetailCollapsableCard.vue?vue&type=script&lang=js&"
export * from "./RefundDetailCollapsableCard.vue?vue&type=script&lang=js&"
import style0 from "./RefundDetailCollapsableCard.vue?vue&type=style&index=0&id=695e41c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e41c2",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CDivider: require('@chakra-ui/vue').CDivider, CBox: require('@chakra-ui/vue').CBox, CGrid: require('@chakra-ui/vue').CGrid, CCollapse: require('@chakra-ui/vue').CCollapse, CImage: require('@chakra-ui/vue').CImage})
